module.exports = __webpack_public_path__ + "static/media/ic_back_login.22493807.svg";